import styles from './Sizes.module.scss';

export const RIGHT_PANEL_WIDTH = parseInt(styles.rightPanelWidth, 10);
export const RIGHT_PANEL_SHIFT_BREAKPOINT = parseInt(
  styles.rightPanelShiftBreakpoint,
  10,
);

const Sizes = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
} as const;

export type Size = (typeof Sizes)[keyof typeof Sizes];

export enum LayoutSize {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
  monitor = 'monitor',
}

export const LAYOUT_MIN_MAX_WIDTHS: Record<LayoutSize, [number, number]> = {
  [LayoutSize.mobile]: [0, 655],
  [LayoutSize.tablet]: [655, 916],
  [LayoutSize.desktop]: [916, 1920],
  [LayoutSize.monitor]: [1920, Number.MAX_SAFE_INTEGER],
};

export const MIN_MAX_WIDTHS: Record<Size, [number, number]> = {
  [Sizes.SM]: [0, 768],
  [Sizes.MD]: [768, 992],
  [Sizes.LG]: [992, Number.MAX_SAFE_INTEGER],
};

export type PostLayoutSize = 'mobile' | 'tablet' | 'desktop' | 'monitor';

const POST_LAYOUT_SIZES: [PostLayoutSize, number][] = [
  ['monitor', 1656],
  ['desktop', 916],
  ['tablet', 655],
  ['mobile', 0],
];

export function getCurrentPostLayoutSize({
  accountForRightPanel,
  baseWidth,
}: {
  accountForRightPanel?: boolean;
  baseWidth: number;
}): PostLayoutSize {
  const width =
    accountForRightPanel && baseWidth >= RIGHT_PANEL_SHIFT_BREAKPOINT
      ? baseWidth - RIGHT_PANEL_WIDTH
      : baseWidth;

  const [size] = POST_LAYOUT_SIZES.find(
    ([, breakpoint]) => width >= breakpoint,
  ) ?? ['mobile', 0];

  return size;
}

export default Sizes;
